import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#28ABE2",
    },
    secondary: {
      main: "#2A3693",
    },
    background: "#FFFFFF",
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: "#FF0000" },
      },
    },
  },
});
